import { render, staticRenderFns } from "./layout-chat-main.vue?vue&type=template&id=6e884041&scoped=true"
import script from "./layout-chat-main.vue?vue&type=script&lang=js"
export * from "./layout-chat-main.vue?vue&type=script&lang=js"
import style0 from "./layout-chat-main.vue?vue&type=style&index=0&id=6e884041&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!D:\\wwwroot\\deepcityAI\\user-client-pc\\user-client-common-pc\\node_modules\\@vue\\vue-loader-v15\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e884041",
  null
  
)

export default component.exports